import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import plugin from './plugin/index'
import store from './store'
import i18n from './lang'

Vue.use(plugin)
// require('../mock')

// import risize from '@/layout/Home/mixin/RisizeTable'
// Vue.mixin(risize)
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js